import { EnvironmentFilter } from '../enums';

export const EnvironmentFilters = [
  { value: EnvironmentFilter.InsuranceFilter, name: 'Insurance Type' },
  { value: EnvironmentFilter.SupportFilter, name: 'Support Type' },
  { value: EnvironmentFilter.HouseholdPersonsFilter, name: 'Persons in household' },
  { value: EnvironmentFilter.StateFilter, name: 'State' },
  { value: EnvironmentFilter.ZipcodeFilter, name: 'Zipcode' },
  { value: EnvironmentFilter.HouseholdIncomeFilter, name: 'Household Income' },
];
